












































import Vue from "vue";
import Util from "./../../lib/util";

export default Vue.extend({
  name: "DefinedDropdownlistSelector",
  components: {},
  props: ["currentModel"],
  data() {
    return {
      visible: false,
      commonList: [],
      myList: [],
      predefinedListName: "",
    };
  },
  mounted() {
    let abp = Util.abp;
    this.commonList = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.CommonTargetScaleList"]) : [];
    this.myList = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.MyTargetScaleList"]) : [];

    this.$Notice.config({
      top: 120,
      duration: 3,
    });
  },
  methods: {
    handleClick(item) {
      this.visible = false;
      this.$emit("on-select", item);
    },
    handleRemove(item) {
      for (var i = 0; i < this.myList.length; i++) {
        if (this.myList[i] === item) {
          this.myList.splice(i, 1);
        }
      }

      this.changeTargetScaleList();
    },
    changeTargetScaleList() {
      this.$store.dispatch("review/changeMyTargetScaleList", { model: JSON.stringify(this.myList) }).then((response) => {
        if (response.data && response.data.success === true) {
          Util.abp.setting.values["App.MyTargetScaleList"] = JSON.stringify(this.myList);
        }

        this.$Notice.success({
          title: "Save",
          desc: "My picklists updated!",
        });
      });
    },
    handleSaveToPredefined() {
      let context = this;
      context.$Modal.confirm({
        render: (h) => {
          return h("div", [
            h("Input", {
              props: {
                value: this.predefinedListName,
                autofocus: true,
                placeholder: "Please enter picklist name...",
              },
              on: {
                input: (val) => {
                  this.predefinedListName = val;
                },
              },
            }),
          ]);
        },
        onOk: async () => {
          let id = 0;
          context.myList.forEach((item) => {
            if (item.value > id) {
              id = item.value;
            }
          });
          id = id + 1;
          context.myList.push({ value: id, label: context.predefinedListName, options: context.currentModel });

          context.changeTargetScaleList();
        },
      });
    },
  },
});
